<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
      />
    </div>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import GroupAssignmentForm from "../../../components/personnel/groupassignment/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": GroupAssignmentForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      copyfromid: this.$route.params.copyfromid,
      search: this.$route.params.search,
      pageTitle: this.$t('recgrpassignment.newgrpassignment'),
      pageTitleValue: "",
      formData: {
        psnid: null,
        staffid: null,
        staffcode: null,
        compnyid: null,
        startdate: null,
        enddate: null,
        override: null,
        remark: null,
        groupitems: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      loading: false,
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    // Copy & Add: prefill everything from the source record except the dates
    async loadCopySource() {
      const vm = this;

      try {
        const hd = await this.$store.dispatch('get', {url: "/groupassignment/" + this.copyfromid});
        const dt = await this.$store.dispatch('get', {url: "/groupassignmentd/" + this.copyfromid});
        const rec = hd.data.rec[0];

        vm.formData.psnid = rec.psnid;
        vm.formData.staffid = rec.staffid;
        vm.formData.staffcode = rec.staffcode;
        vm.formData.compnyid = rec.compnyid;
        vm.formData.compnyname = rec.compnyname;
        vm.formData.remark = rec.remark;
        vm.formData.override = rec.override == "Y";
        vm.formData.lockstaff = true;
        vm.pageTitleValue = rec.psnname;

        vm.formData.groupitems = dt.data.rec.map((d) => ({
          gtypedesc: d.gtypedesc,
          valuecode: d.valvaluecode,
          valuedesc: d.valvaluecodedesc,
          gtypeid: d.gtypeid,
          valvalueid: d.valvalueid,
          action: 1,
        }));
      } catch (err) {
        vm.isErr = true;
        vm.errMsg = err;
      }
    },

    //insert new record
    saveHandler() {
      const vm = this;

      if (this.formData.override == true) {
        this.formData.override = 1;
      } else {
        this.formData.override = 0;
      }

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      const payload = { ...this.formData, copyfromid: this.copyfromid || null };

      this.$store.dispatch('post', {url: "/groupassignment/create", payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "groupassignmentlist", params: { search: this.search } });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "groupassignmentlist" });
    },
  },

  async mounted() {
    if (!this.copyfromid) return;

    this.loading = true;
    try {
      await this.loadCopySource();
    } finally {
      this.loading = false;
    }
  },
};
</script>
